import React from 'react';
import { Chrono } from "react-chrono";

export default function ContentTimeline(props) {
  //console.log('ContentTimeline - props', props);

  const {
    bag
  } = props;
  
  return (
    <>
      <div className={'site-content-timeline'}>
        <Chrono mode="VERTICAL" hideControls cardHeight={'100px'} items={bag.contentItems} />
      </div>
    </>
  )
}
